import { IRenderingCommonContext } from "@commonRendering/types";
import { IElementData } from "@pageBuilder/typings";

export abstract class CascadeRendererBase<TData extends IElementData> {

    protected constructor(protected readonly renderingCommonContext: IRenderingCommonContext) {
    }

    public abstract createByCascade(data: TData): HTMLElement;

    public abstract getDataByCascade(element: HTMLElement): TData | null;

}